
module.exports = require("naughty-words/en.json");